import request from '../utils/request'

const roleService = {
    // 获取角色列表
    getRolesByTenantId: (tenantId) => {
        return request({
            url: '/role/tenantAll',
            method: 'post',
            data:{tenantId}
        })
    },

    // 获取角色详情
    // 获取当前用户角色信息
    getRolesByUserId: (userId) => {
        return request({
            url: '/role/userId',
            method: 'post',
            data:{userId}
        })
    },

    getRolePermissions: (roleId) => {
        return request({
            url: '/role/permissions',
            method: 'post',
            data:{roleId}
        })
    },

    // 创建角色
    create: (data) => {
        return request({
            url: '/role',
            method: 'post',
            data
        })
    },

    // 更新角色
    update: (id, data) => {
        return request({
            url: `/role/${id}`,
            method: 'put',
            data
        })
    },

    // 删除角色
    delete: (id) => {
        return request({
            url: `/role/${id}`,
            method: 'delete'
        })
    },
}

export default roleService
